import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";

import { useFormik } from "formik";

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import trainerRoutes from "../../../pages/trainer/routes";
import { getLocalUserProfile } from "../../../services/auth.service";
import coursesService from "../../../services/courses.service";
import trainerAssignmentService from "../../../services/trainer/trainer-assignment.service";
import { getCurrentDateTime } from "../../../utils/dates";

export const QuestionTopicModal: React.FC<any> = ({
  isOpen,
  onClose,
  isQuestionTopic = false,
  courseId,
  ass_type,
}: {
  isOpen: any;
  onClose: any;
  isQuestionTopic: boolean;
  courseId: string;
  ass_type: string;
}) => {
  const [exam_type, setExamType] = useState<any[]>([]);
  const [trainerid, setTrainerId] = useState(0);
  const toast = useToast();
  const [session, setSession] = useState<number>();
  const [term, setTerms] = useState<number>();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [batchFile, setbatchFile] = useState<File | undefined>();
  const [filename, setFilename] = useState("");
  const navigate = useNavigate();

  const examtype = [
    {
      id: "1",
      title: "Exam",
    },
    {
      id: "2",
      title: "Assignment",
    },
    {
      id: "3",
      title: "Test",
    },
    {
      id: "4",
      title: "Classwork",
    },
  ];
  useEffect(() => {
    const trainer = getLocalUserProfile();
    if (trainer) setTrainerId(trainer.id);

    //Exam,Assignment,Test,ClassWork

    setExamType(examtype);

    coursesService
      .getAvailableCourses()
      .then((response) => {
        const available_course = response.filter(
          (each) => each.course.uuid == courseId
        );
        if (available_course.length > 0) {
          setTerms(available_course[0].term_id);
          setSession(available_course[0].session_id);
        }
      })
      .catch((err) => err);
  }, []);

  const cancelRef = useRef().current;

  const formik = useFormik({
    validate: (values: any) => {
      console.log(values)
      const errors: any = {};

      // Title validation
      if (!values.title) {
        errors.title = "Title is required";
      }

      // Description validation
      if (!values.description) {
        errors.description = "Description is required";
      }

      // Start Date validation
      if (!values.start_date) {
        errors.start_date = "Start date is required";
      } else {
        const currentDate = new Date();
        const startDate = new Date(values.start_date);
        if (startDate < currentDate) {
          errors.start_date = "Start date cannot be in the past";
        }
      }

      // End Date validation
      if (!values.end_date) {
        errors.end_date = "End date is required";
      } else {
        const startDate = new Date(values.start_date);
        const endDate = new Date(values.end_date);
        if (endDate <= startDate) {
          errors.end_date = "End date must be after the start date";
        }
      }

      // Pass Mark validation
      if (!values.pass_mark) {
        errors.pass_mark = "Pass mark is required";
      } else {
        const passMark = Number(values.pass_mark);
        if (isNaN(passMark) || passMark < 0 || passMark > 100) {
          errors.pass_mark = "Pass mark must be a number between 0 and 100";
        }
      }


      if (!values.category) {
        errors.category = "Category is required";
      } 
      // Template validation
      if (ass_type == "Quiz" && !batchFile) {
        errors.template = "Template is required";
      }

      console.log(errors, "errorssss");

      return errors;

    },
    //Exam,Assignment,Test,ClassWork
    initialValues: {
      title: "",
      description: "",
      start_date: "",
      end_date: "",
      pass_mark: "",
      category: "",
      template: "",
    },
    onSubmit: async (values) => {
      const assignmentInfo: any = {
        type: ass_type,
        category: values.category,
        instructor_id: trainerid,
        course_id: courseId,
        title: values.title,
        description: values.description,
        start_date: values.start_date,
        end_date: values.end_date,
        pass_mark: values.pass_mark,
        session_id: session,
        term_id: term,
        is_active: 1,
      };

      try {
        if (ass_type == "Quiz") {
          const formData = new FormData();
          formData.append("type", ass_type);
          formData.append("category", values.category);
          formData.append("instructor_id", trainerid.toString());
          formData.append("course_id", courseId);
          formData.append("title", values.title);
          formData.append("description", values.description);
          formData.append("start_date", values.start_date);
          formData.append("end_date", values.end_date);
          formData.append("pass_mark", values.pass_mark);
          if (session) formData.append("session_id", session.toString());
          if (term) formData.append("term_id", term.toString());
          formData.append("is_active", "1");
          if (batchFile) formData.append("template", batchFile);
          const basicResponse =
            await trainerAssignmentService.createAssignmentQuiz(
              courseId,
              formData
            );
          if (basicResponse) {
            onClose();
            formik.resetForm();
            navigate(`/trainer/course/${courseId}/assignments`);

            toast({
              title: "Assessment",
              description: "Assessment created successfully",
              status: "success",
            });
          }
        } else {
          const basicResponse =
            await trainerAssignmentService.createAssignmentTopic(
              assignmentInfo
            );
          // const course_uuid = basicResponse.data.uuid
          if (basicResponse) {
            localStorage.setItem(
              "naptin_assignment",
              JSON.stringify(basicResponse.data)
            );
            onClose();
            formik.resetForm();
            navigate(
              trainerRoutes.trainerCourses.TheoryQuestionsLink(courseId)
            );
            toast({
              title: "Assessment Topic",
              description: "Assessment topic created successfully",
              status: "success",
            });
          }
        }
      } catch (error: any) {
        toast({
          title: "Assessment Topic",
          description: error.response.data.message,
          status: "error",
        });
      } finally {
        setFilename("");
        formik.resetForm();
        
      }
    },
  });

  // const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = e.target.value;

  //   if (value) {
  //     const fileName = e.target.files?.item(0)?.name as string;
  //     setFilename(fileName);

  //     //   "The file must be a file of type: png, jpg, jpeg, mp4, mp3, pdf, doc, docx."
  //     const fileType = e.target.files?.item(0)?.type;
  //     const file = e.target.files?.item(0) as File;
  //     setbatchFile(file);
  //   } else {
  //     setFilename("");
  //     setbatchFile(undefined);
  //   }

  //   formik.handleChange(e);
  // };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.item(0);
  
    if (file) {

      const validFileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
      if (!validFileTypes.includes(file.type)) {
        toast({
          title: "Invalid File Type",
          description: "Please upload a valid Excel file.",
          status: "error",
        });

        e.target.value = "";
        return;
      }
  

      const fileName = file.name;
      setFilename(fileName);
      setbatchFile(file);
    } else {
      setFilename("");
      setbatchFile(undefined);
    }
  

    formik.handleChange(e);
  };
  

  const handleCloseModal = () => {
    formik.resetForm();
    onClose();
  }

  return (
    <>
      <Modal
        isOpen={isOpen && isQuestionTopic}
        onClose={handleCloseModal}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="lg"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={3}>
          <ModalHeader>
            <Flex justifyContent="center">
              <Box>
                <Flex justifyContent="center">
                  <Text
                    mx="auto"
                    color="#353535"
                    fontSize="24px"
                    fontWeight="800"
                  >
                    Assessment Information
                  </Text>
                </Flex>
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton size="sm" />

          <ModalBody>
            <Box mt={4}>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.title && formik.touched.title ? true : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Assessment Topic
                  </FormLabel>
                  <Input
                    bg="inputText.500"
                    placeholder="Enter assignment topic"
                    value={formik.values.title}
                    name="title"
                    onChange={formik.handleChange}
                    fontSize="14px"
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.title}
                  </FormErrorMessage>
                </FormControl>

                <FormControl
                  mb="26px"
                  id="description"
                  isInvalid={
                    formik.errors.description && formik.touched.description
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Instruction{" "}
                  </FormLabel>
                  <Textarea
                    p={4}
                    bg="inputText.500"
                    fontSize={12}
                    size="sm"
                    minH="100px"
                    name="description"
                    onChange={formik.handleChange}
                    value={formik.values.description}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.description}
                  </FormErrorMessage>
                </FormControl>

                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.pass_mark && formik.touched.pass_mark
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Pass Mark
                  </FormLabel>
                  <Input
                    bg="inputText.500"
                    type={"number"}
                    placeholder="Enter pass mark"
                    value={formik.values.pass_mark}
                    name="pass_mark"
                    onChange={formik.handleChange}
                    fontSize="14px"
                  />

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.pass_mark}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.start_date && formik.touched.start_date
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Start Date
                  </FormLabel>
                  <Input
                    bg="inputText.500"
                    type="datetime-local"
                    placeholder="Enter start date"
                    value={formik.values.start_date}
                    name="start_date"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    min={getCurrentDateTime()}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.start_date}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.end_date && formik.touched.end_date
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    End Date
                  </FormLabel>
                  <Input
                    bg="inputText.500"
                    type="datetime-local"
                    placeholder="Enter end date"
                    value={formik.values.end_date}
                    name="end_date"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    min={getCurrentDateTime()}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.end_date}
                  </FormErrorMessage>
                </FormControl>

                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.category && formik.touched.category
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Category
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select category"
                    value={formik.values.category}
                    name="category"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {exam_type.map((each, index) => (
                      <option key={index} value={each.title}>
                        {" "}
                        {each.title}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.category}
                  </FormErrorMessage>
                </FormControl>
                {ass_type == "Quiz" && (
                  <Box>
                    {filename ? (
                      <Box>
                        <Table variant="unstyled">
                          <Thead fontWeight="semibold">
                            <Tr color="brand.subtitle" fontSize={14}>
                              <Td>Filename</Td>
                              <Td>Type</Td>
                              <Td>Size</Td>
                            </Tr>
                          </Thead>

                          <Tbody>
                            <Tr fontSize={13} color="brand.subtitle">
                              <Td maxW="20em">{filename}</Td>
                              <Td>{filename}</Td>
                              <Td>{uploadFileSize}</Td>
                            </Tr>
                          </Tbody>
                        </Table>
                      </Box>
                    ) : (
                      <FormControl mr={10}       isInvalid={
                        formik.errors.template && formik.touched.template
                          ? true
                          : false
                      }>
                        <FormLabel
                          fontWeight="600"
                          color="#616161"
                          fontSize={13}
                        >
                          Upload Question File
                        </FormLabel>
                        <Text fontWeight="400" color="#959595" fontSize="14px">
                          Upload an excel template of the questions.
                        </Text>

                        <input
                          type="file"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          name="template"
                          ref={inputRef}
                          onChange={(e) => handleFileChange(e)}
                          style={{ display: "none" }}
                        ></input>
                        <Input
                          cursor="pointer"
                          placeholder="No file selected"
                          defaultValue={filename}
                          mt="10px"
                          borderColor="#eeeeee"
                          fontSize={14}
                          bg="#fafafa"
                          onClick={() => inputRef?.current?.click()}
                          border="2px dashed"
                          borderRadius={2}
                        />

                        <FormErrorMessage fontSize={12}>
                          {" "}
                          {formik.errors.template}{" "}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Box>
                )}

                <Flex mt={12} justifyContent="end">
                  <HStack>
                    <Button
                      colorScheme="red"
                      type="submit"
                      size="sm"
                      px={6}
                      fontSize={12}
                    >
                      SAVE
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
